import { postalCodeEndpoint, stateEndpoint } from '../microsservices/AccountsApi';

import { IAddress } from '@/interfaces/Address';
import { ICities } from '@/interfaces/Cities';

export function getZipCode(postalCode: string): Promise<any> {
  return postalCodeEndpoint.get<IAddress>({
    uriParams: {
      postalCode,
    },
  });
}

export function getCitiesFromState(state: string): Promise<any> {
  return stateEndpoint.get<ICities>({
    headers: { head: 'noHeader' },
    uriParams: {
      state,
    },
  });
}
